import Hls from 'hls.js';

addHeroVideoSupport();
registerVideoPlayButtonEventListeners();

function addHeroVideoSupport() {
	const hideVideo = window.matchMedia( '(max-width: 991px)' ).matches;
	if ( hideVideo ) {
		return;
	}

	document.querySelectorAll( '.video-block .video-cover' ).forEach( videoCover => {
		videoCover.style.backgroundColor = '#000';

		const videoPlayer = videoCover.querySelector( 'video' );

		loadVideo( videoPlayer );
		videoPlayer.play();
	} );
}

function registerVideoPlayButtonEventListeners() {
	document.querySelectorAll( '.btn-play-video' ).forEach( videoPlayButton => {
		addVideoPlayButtonEventListener( videoPlayButton );
	} );
}

function addVideoPlayButtonEventListener( videoPlayButton ) {
	videoPlayButton.addEventListener( 'click', async event => {
		const clickedVideoPlayButton = event.currentTarget;
		const videoModule = clickedVideoPlayButton.closest( '.video-module' );
		const videoCover = videoModule.querySelector( '.video-cover' );
		const videoContainer = videoModule.querySelector( '.video-container' );
		const videoPlayer = videoContainer.querySelector( 'video' );
		const abortController = new AbortController();

		const closeOverlay = () => {
			if ( supportsNativeFullscreen( videoPlayer ) && isNativeFullscreen( videoPlayer ) ) {
				return;
			}

			videoPlayer.pause();

			videoModule.classList.remove( 'active' );
			videoCover.classList.remove( 'hide' );
			videoContainer.classList.add( 'hide' );

			abortController.abort();
		};

		videoPlayer.addEventListener( 'webkitendfullscreen', closeOverlay, { signal: abortController.signal } );
		videoPlayer.addEventListener( 'fullscreenchange', closeOverlay, { signal: abortController.signal } );

		videoContainer.addEventListener( 'click', videoContainerClickEvent => {
			if ( [ 'VIDEO', 'FIGCAPTURE' ].includes( videoContainerClickEvent.target.tagName ) ) {
				return;
			}

			closeOverlay();
		}, { signal: abortController.signal } );

		loadVideo( videoPlayer );

		videoModule.classList.add( 'active' );
		videoCover.classList.add( 'hide' );
		videoContainer.classList.remove( 'hide' );

		await videoPlayer.play();
	} );
}

function supportsNativeFullscreen( videoPlayer ) {
	return document.fullscreenEnabled ||
		( 'webkitSupportsFullscreen' in videoPlayer && videoPlayer.webkitSupportsFullscreen );
}

function isNativeFullscreen( videoPlayer ) {
	return ( 'fullscreenElement' in document && document.fullscreenElement ) ||
		( 'webkitDisplayingFullscreen' in videoPlayer && videoPlayer.webkitDisplayingFullscreen );
}

function loadVideo( videoPlayer ) {
	// If data has already started loading, we shouldn't reset it/start over.
	if ( [ videoPlayer.HAVE_FUTURE_DATA, videoPlayer.HAVE_ENOUGH_DATA ].includes( videoPlayer.readyState ) ) {
		return;
	}

	if ( Hls.isSupported() ) {
		addCloudflareStreamToVideo( videoPlayer );

		return;
	}

	// If the metadata isn't immediately available, playing the video will result in an error on iOS.
	// So we need to tap into 'canplay', if we need to load metadata first.
	// videoPlayer.addEventListener( 'canplay', () => videoPlayer.play() );
	videoPlayer.load();
}

function addCloudflareStreamToVideo( videoPlayer ) {
	const hls = new Hls();

	hls.attachMedia( videoPlayer );
	hls.on( Hls.Events.MEDIA_ATTACHED, () => {
		hls.loadSource( `https://videodelivery.net/${ videoPlayer.dataset.videoId }/manifest/video.m3u8` );
	} );
}
